let controller = new AbortController();

export const getControllerSignal = (): AbortSignal => controller.signal;

export const abortController = (): void => {
  controller.abort();
};

export const reinitController = (): void => {
  controller = new AbortController();
};
